<template>
  <div id="image-slider" class="splide" :key="updatedKey">
    <div class="splide__track">
      <ul class="splide__list">
        <li class="splide__slide" v-for="(image, index) in getCurrentViewFiles" :key="index">
          <div class="background-image" :style="{'background-image': 'url('+image.url+')'}"></div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
const splide = require('@splidejs/splide')
import {mapGetters} from "vuex";

export default {
  name: "ImageSlider",
  mounted() {
    this.$nextTick(() => {
      new splide.Splide('#image-slider', {
        type    : 'loop',
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: this.getCurrentViewContent && this.getCurrentViewContent.interval_period ? this.getCurrentViewContent.interval_period * 1000 : 10000
      }).mount()
    })
  },
  watch: {
    getCurrentViewFiles: {
        handler() {
            this.updatedKey += 1
            this.$nextTick(() => {
                new splide.Splide('#image-slider', {
                    type    : 'loop',
                    autoplay: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    interval: this.getCurrentViewContent && this.getCurrentViewContent.interval_period ? this.getCurrentViewContent.interval_period * 1000 : 10000
                }).mount()
            })
        }
    }
  },
  data() {
    return {
        updatedKey: 0
    }
  },
  computed: {
    ...mapGetters({
      getCurrentViewContent: 'getCurrentViewContent',
      getCurrentViewFiles: 'getCurrentViewFiles',
      getCustomerId: 'getCustomerId',
      getResourcePath: 'getResourcePath'
    })
  }
}
</script>

<style>
.splide__arrows {
  display: none;
}
.splide__pagination {
  display: none !important;
}
.splide__track {
  height: 100%;
}
.splide__track ul li {
  display: inline-block !important;
}
#image-slider {
  background-color: black;
  height: 100vh;
}
.splide__slide .background-image {
  height: 100%;
}
.background-image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: auto;
  width: 100%;
  height: 100%;
  display: inline-block;
}
@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide__track--fade>.splide__list{display:block}.splide__track--fade>.splide__list>.splide__slide{left:0;opacity:0;position:absolute;top:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;position:relative;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}
</style>
